module.exports = __webpack_public_path__ + "07e4c95992536fee1be0ccedffa7514b.png";